module.exports = __webpack_public_path__ + "img/ja-new.8542aad3.svg";